import {useEffect, useLayoutEffect} from 'react'

import useLocalStorageState from './use-local-storage-state'

export default function useWindowScrollYPosition(
  localStorageKey: string,
  setCondition: boolean
): void {
  const [scrollYStorage, setScrollYStorage] = useLocalStorageState(localStorageKey, 0)

  // Get scroll position before the browser repaints the screen
  useLayoutEffect(() => {
    return () => {
      const scrollY = window.scrollY
      setScrollYStorage(scrollY)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (setCondition) {
      window.scrollTo(0, scrollYStorage)
    }
  }, [setCondition, scrollYStorage])
}
